// @flow

import React from 'react';
import styled from 'styled-components';
import Divider from '../../../divider';
import type { Theme } from '../../../../types';
import LinkComponent from '../../../link';
import { dateParser, dateFormatter } from '../../../../helpers';

const Date = styled<any, Theme>('p')`
  color: ${props => props.theme.news.dateColor};
  margin: 1rem 0 0 0;
`;

const Title = styled<any, Theme>('h4')`
  color: ${props => props.theme.news.titleColor};
  margin: 0.25rem 0 0 0;
`;

const Link = styled<typeof LinkComponent, Theme>(LinkComponent)`
  text-decoration: none;
`;

type Props = {
  date: string,
  title: string,
  link: string,
};

const OverviewItem = ({
  date,
  title,
  link,
}: Props) => (
  <Link href={link}>
    <Divider width="100%" />
    <Date>{dateFormatter(dateParser(date))}</Date>
    <Title>{title}</Title>
  </Link>
);

export default OverviewItem;
